import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import { cashCheckout1Event } from "@/utils/dataLayerEvents";
import { useState } from "react";
import { CDN_LINK } from "@globalConfig";
import LimitedAvaInfoBox from "./components/LimitedAvaInfoBox/LimitedAvaInfoBox";
import stl from "./LimitedAvaPostViewBtn.module.css";
import { trackEvents } from "@/common/events/events";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import useContactNumbers from "@hooks/useContactNumbers";
import CarColorVariation from "@/pages/post/PostViewComponents/components/CarColorVariation/CarColorVariation";
var LimitedAvaPostViewBtn = function LimitedAvaPostViewBtn(_ref) {
  var _post$color_variants, _post$color_variants2, _post$details_card, _post$details_card$ex, _post$details_card2, _post$details_card2$e;
  var footer_section = _ref.footer_section,
    postId = _ref.postId,
    g4_data = _ref.g4_data,
    desktop = _ref.desktop,
    _ref$have_finance = _ref.have_finance,
    have_finance = _ref$have_finance === void 0 ? false : _ref$have_finance,
    post = _ref.post;
  var _useState = useState(false),
    showNumbers = _useState[0],
    setShowNumbers = _useState[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var contactNumbers = useContactNumbers();
  var _useHelpers2 = useHelpers(),
    navigateToHard = _useHelpers2.navigateToHard;
  var showImagesDisclaimer = function showImagesDisclaimer() {
    var _post$gallery, _post$gallery$images;
    if (((_post$gallery = post.gallery) === null || _post$gallery === void 0 ? void 0 : (_post$gallery$images = _post$gallery.images) === null || _post$gallery$images === void 0 ? void 0 : _post$gallery$images.length) > 0) {
      var _post$gallery$images2, _post$gallery$images3, _post$gallery$images4, _post$gallery$images5;
      var exteriorImages = (_post$gallery$images2 = post.gallery.images) === null || _post$gallery$images2 === void 0 ? void 0 : (_post$gallery$images3 = _post$gallery$images2.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "exterior";
      })) === null || _post$gallery$images3 === void 0 ? void 0 : _post$gallery$images3.length;
      var interiorImages = (_post$gallery$images4 = post.gallery.images) === null || _post$gallery$images4 === void 0 ? void 0 : (_post$gallery$images5 = _post$gallery$images4.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.img_type) === "interior";
      })) === null || _post$gallery$images5 === void 0 ? void 0 : _post$gallery$images5.length;
      return exteriorImages < 5 || interiorImages < 5;
    }
    return false;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, desktop && /*#__PURE__*/React.createElement("div", {
    className: [stl.limitedAvailability, (post === null || post === void 0 ? void 0 : (_post$color_variants = post.color_variants) === null || _post$color_variants === void 0 ? void 0 : _post$color_variants.length) > 0 ? "mb-0" : ""].join(" ")
  }, /*#__PURE__*/React.createElement(LimitedAvaInfoBox, null)), (post === null || post === void 0 ? void 0 : (_post$color_variants2 = post.color_variants) === null || _post$color_variants2 === void 0 ? void 0 : _post$color_variants2.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "w-full mb-4"
  }, /*#__PURE__*/React.createElement(CarColorVariation, {
    colors: post === null || post === void 0 ? void 0 : post.color_variants,
    onColorClick: function onColorClick(color) {
      var _color$name_en;
      trackEvents("car_color_selected", {
        referral_location: "post_details",
        post_id: postId,
        selected_color: (_color$name_en = color === null || color === void 0 ? void 0 : color.name_en) !== null && _color$name_en !== void 0 ? _color$name_en : '',
        post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
        post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model
      });
      navigateToHard("/cardetail/".concat(color.post_id));
    },
    currentColorCode: post === null || post === void 0 ? void 0 : (_post$details_card = post.details_card) === null || _post$details_card === void 0 ? void 0 : (_post$details_card$ex = _post$details_card.exterior_color) === null || _post$details_card$ex === void 0 ? void 0 : _post$details_card$ex.code,
    currentColorName: post === null || post === void 0 ? void 0 : (_post$details_card2 = post.details_card) === null || _post$details_card2 === void 0 ? void 0 : (_post$details_card2$e = _post$details_card2.exterior_color) === null || _post$details_card2$e === void 0 ? void 0 : _post$details_card2$e.name,
    showDisclaimer: showImagesDisclaimer()
  })), !showNumbers && /*#__PURE__*/React.createElement("div", {
    className: stl.limitedAvailability
  }, /*#__PURE__*/React.createElement(Link, {
    className: ["greenBtn", stl.btn, stl.reserveBtn].join(" "),
    to: createUrl(have_finance ? "/pre-checkout/".concat(postId) : "/checkout/shop-apply?post_id=".concat(postId)),
    onClick: function onClick() {
      cashCheckout1Event("limited_availability", g4_data);
    }
  }, footer_section.reserve_btn_text), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowNumbers(true);
    },
    className: ["greenTextBtn", stl.callUsBtn, stl.btn].join(" ")
  }, /*#__PURE__*/React.createElement("img", {
    className: "m-show",
    src: CDN_LINK + "/assets/images/CallGreen.svg",
    alt: "call",
    width: 18,
    height: 18
  }), t("اتصل بنا للحجز", {
    ns: "web_post_view"
  }))), showNumbers && /*#__PURE__*/React.createElement("div", {
    className: stl.callUsBy
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setShowNumbers(false);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/close_search.svg",
    alt: ""
  })), /*#__PURE__*/React.createElement("strong", null, t("تواصل معنا عن طريق", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("a", {
    href: "tel:".concat(contactNumbers.callCenterCallNumber),
    className: stl.SOLcallus,
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: postId,
        contact_type: "call",
        contact_location: "Car Details"
      });
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/Call.svg",
    alt: ""
  }), /*#__PURE__*/React.createElement("span", null, t("اتصال", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      direction: "ltr"
    }
  }, contactNumbers.callCenterDisplayNumber)), /*#__PURE__*/React.createElement("a", {
    href: "https://api.whatsapp.com/send?phone=".concat(contactNumbers.whatsappCallNumber, "&amp;"),
    rel: "noopener noreferrer",
    target: "_blank",
    className: stl.SOLwhatus,
    onClick: function onClick() {
      trackEvents("online_contact", {
        post_id: postId,
        contact_type: "whatsapp",
        contact_location: "Car Details"
      });
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/bundles/wpImg.svg",
    alt: "",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("span", null, t("واتساب", {
    ns: "web_post_view"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      direction: "ltr"
    }
  }, contactNumbers.whatsappDisplayNumber))));
};
export default LimitedAvaPostViewBtn;